import { useEffect, useState } from 'react'
import { db } from '../firebase/config'

const chunk = (arr, size) => {
    const out = []
    for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size))
    return out
}

/**
 * Namen (`CompagnyMeta.CommunityName`) bij een lijst organisatie-ids, voor de
 * beheerweergaven van een benchmark. Een organisatie zonder naam houdt haar id.
 *
 * Alleen voor het beheerteam: klanten zien elkaar anoniem, en de ids in een
 * benchmark komen alleen in de beheerweergave mee. Leest per `CompagnyID`, in
 * blokken van 10 (de grens van een 'in'-query).
 * AI-CONTEXT: See docs/pitfalls.md#database-missing-compagnyid-on-fresh-fetch
 *
 * @param {Array<string>} companyIds
 * @returns {Map<string, string>} companyId → naam
 */
const useCompanyNames = (companyIds) => {
    const [names, setNames] = useState(/** @type {Map<string, string>} */ (new Map()))
    // Primitieve sleutel: een vers array met dezelfde ids start geen nieuwe read.
    // AI-CONTEXT: See docs/pitfalls.md#state-useeffect-inline-filter
    const key = (companyIds || []).filter(Boolean).join(',')

    useEffect(() => {
        const ids = key ? key.split(',') : []
        if (!ids.length) return undefined
        let cancelled = false

        const laden = async () => {
            const map = new Map()
            for (const batch of chunk(ids, 10)) {
                // eslint-disable-next-line no-await-in-loop
                const snap = await db.collection('CompagnyMeta').where('CompagnyID', 'in', batch).get()
                snap.docs.forEach((d) => {
                    const data = d.data()
                    map.set(data.CompagnyID, data.CommunityName || data.CompagnyID)
                })
            }
            ids.forEach((id) => { if (!map.has(id)) map.set(id, id) })
            return map
        }

        laden()
            .then((map) => { if (!cancelled) setNames(map) })
            // Zichtbaar falen; de weergave valt dan terug op ids of anonieme labels.
            .catch((err) => console.error('useCompanyNames:', err))

        return () => { cancelled = true }
    }, [key])

    return names
}

export default useCompanyNames
